shvenergy.contactbannerwithopeninghours = (function ($) {
	"use strict";

	function init() {

		var banners = $(".support-banner__container--contact");

		banners.each(function() {

			var currentBanner = $(this);

			var but = currentBanner.find("button.timeslot");
			var timeslots = currentBanner.find("div.timeslot");

			but.on("click", function() {

				var attribute = $(this).attr("aria-expanded");
				var newAttr = attribute === "false" ? "true" : "false";
				$(this).attr("aria-expanded", newAttr);
				timeslots.toggleClass("active");
			});

		});

	}

	init();

})(jQuery);